export const DEHYDRATED = 'DEHYDRATED';
export const HYDRATED = 'HYDRATED';

/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking
if (!!module && !!module.exports) {
  module.exports.default = Object.assign({}, module.exports);
}